export default {
  data () {
    return {
      localStorageSyncConfigKey: '',
      localStorageData: '{}'
    }
  },
  methods: {
    $loadData () {
      const item = localStorage.getItem(this.localStorageSyncConfigKey)
      if (item) {
        this.localStorageData = item
      }
    },
    $storeData (value) {
      this.localStorageData = JSON.stringify(value)
      localStorage.setItem(this.localStorageSyncConfigKey, this.localStorageData)
    }
  },
  computed: {
    $syncDataToLocalStorage () {
      return JSON.parse(this.localStorageData)
    }
  }
}
